var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBillete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 21.3333H25.3332V10.6666H18.6665V21.3333ZM21.3332 18.6666V13.3333H22.6665V18.6666H21.3332ZM10.6665 21.3333H17.3332V10.6666H10.6665V21.3333ZM13.3332 18.6666V13.3333H14.6665V18.6666H13.3332ZM6.6665 21.3333H9.33317V10.6666H6.6665V21.3333ZM2.6665 26.6666V5.33325H29.3332V26.6666H2.6665Z",
    fill: "#285171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBillete);
export default __webpack_public_path__ + "static/media/ic_billete.72df00afbf7bb057a151c3475be54c0f.svg";
export { ForwardRef as ReactComponent };